module.exports = __webpack_public_path__ + "assets/images/health_g.f39b37e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/health_g.png
// module id = 726
// module chunks = 1